<style>
  .editorial-image {
    width: 100%;
    aspect-ratio: var(--aspect-ratio);
    overflow: hidden;
    background: radial-gradient(circle at center, #2a2a2a 0%, #1a1a1a 100%);
    position: relative;
  }

  .editorial-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.7;
    filter: grayscale(100%);
    transition: all 700ms cubic-bezier(0.25, 1, 0.5, 1);
    position: absolute;
    top: 0;
    left: 0;
  }

  .editorial-image img.loaded {
    position: relative;
  }

  .editorial-image:hover img {
    opacity: 1;
    filter: grayscale(0%);
  }
</style>

<script>
  let { filename, alt = "", aspectRatio = "3/2", onclick } = $props();

  const thumbSrc = `./thumb_images/${filename}`;
  const mediumSrc = `./medium_images/${filename}`;

  let currentSrc = $state(thumbSrc);
  let mediumLoaded = $state(false);

  function handleMediumLoad() {
    mediumLoaded = true;
    currentSrc = mediumSrc;
  }
</script>

<div
  class="editorial-image"
  style="--aspect-ratio: {aspectRatio}"
  {onclick}
  style:cursor={onclick ? "pointer" : "default"}
>
  <img src={currentSrc} {alt} class:loaded={mediumLoaded} />
  <img
    src={mediumSrc}
    {alt}
    style="opacity: 0; position: absolute; pointer-events: none;"
    onload={handleMediumLoad}
  />
</div>
